/* Bulldog Winch theme scripts */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return withCommas;
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var items = $$('.reveal');
    if (!document.body.classList.contains('animate') || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    $$('.has-dropdown > button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.parentElement;
        var open = !item.classList.contains('is-open');
        $$('.has-dropdown.is-open').forEach(function (o) { o.classList.remove('is-open'); o.firstElementChild.setAttribute('aria-expanded', 'false'); });
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.has-dropdown')) {
        $$('.has-dropdown.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      }
    });
    $$('[data-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = $(btn.getAttribute('data-toggle'));
        if (!target) return;
        var willOpen = target.hidden;
        $$('.mobile-panel').forEach(function (p) { p.hidden = true; });
        $$('[data-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        target.hidden = !willOpen;
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) { var input = target.querySelector('input[type="search"]'); if (input) input.focus(); }
      });
    });
  }

  /* ---------- Product card thumbnails ---------- */
  function initCardThumbs() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-card-thumb]');
      if (!thumb) return;
      e.preventDefault();
      e.stopPropagation();
      var card = thumb.closest('.product-card');
      var main = card && card.querySelector('.product-card__image');
      if (main) { main.removeAttribute('srcset'); main.src = thumb.getAttribute('data-card-thumb'); }
      $$('[data-card-thumb]', card).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  }

  /* ---------- Cart ---------- */
  var drawer = $('#CartDrawer');

  function openDrawer() {
    if (!drawer) { window.location.href = theme.routes.cart_url; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function refreshCart() {
    var url = (theme.routes.root_url || '/').replace(/\/?$/, '/') + '?section_id=cart-drawer-items';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = $('#CartDrawerContent');
        var countEl = doc.querySelector('[data-cart-count]');
        var count = countEl ? countEl.textContent.trim() : null;
        if (countEl) countEl.remove();
        var wrapper = doc.querySelector('.shopify-section') || doc.body;
        if (content) content.innerHTML = wrapper.innerHTML;
        if (count !== null) $$('[data-cart-count-label]').forEach(function (el) { el.textContent = count; });
      });
  }

  function addToCart(body) {
    return fetch(theme.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Error');
        return data;
      });
    });
  }

  function initCart() {
    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openDrawer(); } });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

      var change = e.target.closest('[data-line-change]');
      if (change) {
        e.preventDefault();
        if (drawer) drawer.classList.add('is-loading');
        fetch(theme.routes.cart_change_url + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: change.getAttribute('data-line-change'), quantity: parseInt(change.getAttribute('data-qty'), 10) })
        }).then(refreshCart).finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
        return;
      }

      var quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        e.stopPropagation();
        quick.disabled = true;
        addToCart({ items: [{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }] })
          .then(refreshCart)
          .then(openDrawer)
          .catch(function (err) { window.alert(err.message); })
          .finally(function () { quick.disabled = false; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var priceEl = $('[data-variant-price]', section);
    var compareEl = $('[data-variant-compare]', section);
    var skuEl = $('[data-variant-sku]', section);
    var errorEl = $('[data-product-error]', section);
    var mainImg = $('.product-gallery__image', section);
    var partLabel = (skuEl && skuEl.textContent.indexOf('#') > -1) ? skuEl.textContent.split('#')[0] + '#' : 'Part #';

    var current = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];
    var selected = current ? current.options.slice() : [];

    function setMain(src, mediaId) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      $$('[data-gallery-thumb]', section).forEach(function (t) {
        t.classList.toggle('is-active', mediaId ? t.getAttribute('data-media-id') === String(mediaId) : t.getAttribute('data-gallery-thumb') === src);
      });
    }

    $$('[data-gallery-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () { setMain(thumb.getAttribute('data-gallery-thumb'), thumb.getAttribute('data-media-id')); });
    });

    function updateAvailability() {
      $$('.option-btn', section).forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-option-value');
        var test = selected.slice(); test[idx] = val;
        var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
        btn.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    function applyVariant(variant) {
      current = variant;
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = theme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        compareEl.hidden = !(variant.compare_at_price > variant.price);
        if (variant.compare_at_price) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (skuEl) skuEl.textContent = variant.sku ? partLabel + variant.sku : '';
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      $$('[data-variant-copy]', section).forEach(function (el) { el.hidden = el.getAttribute('data-variant-copy') !== String(variant.id); });
      var specBlocks = $$('[data-variant-specs]', section);
      if (specBlocks.length) {
        var hasOwn = specBlocks.some(function (el) { return el.getAttribute('data-variant-specs') === String(variant.id); });
        specBlocks.forEach(function (el, i) { el.hidden = hasOwn ? el.getAttribute('data-variant-specs') !== String(variant.id) : i !== 0; });
      }
      if (variant.featured_media && variant.featured_media.preview_image && $('[data-media-id]', section)) {
        var thumb = $('[data-media-id="' + variant.featured_media.id + '"]', section);
        setMain(thumb ? thumb.getAttribute('data-gallery-thumb') : variant.featured_media.preview_image.src, variant.featured_media.id);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateAvailability();
    }

    $$('.option-btn', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        selected[idx] = btn.getAttribute('data-option-value');
        $$('.option-btn[data-option-index="' + idx + '"]', section).forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
        var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
        applyVariant(variant);
      });
    });
    updateAvailability();

    $$('[data-qty-step]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = $('.qty__input', section);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var qtyInput = $('.qty__input', section);
        addBtn.disabled = true;
        var prev = addLabel.textContent;
        addLabel.textContent = theme.strings.adding;
        addToCart({ items: [{ id: parseInt(idInput.value, 10), quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 }] })
          .then(refreshCart)
          .then(openDrawer)
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .finally(function () { addBtn.disabled = current ? !current.available : true; addLabel.textContent = prev; });
      });
    }

    var specsBtn = $('[data-specs-toggle]', section);
    if (specsBtn) {
      var panel = document.getElementById(specsBtn.getAttribute('aria-controls'));
      var label = $('[data-specs-label]', specsBtn);
      specsBtn.addEventListener('click', function () {
        if (!panel) return;
        var open = panel.hidden;
        panel.hidden = !open;
        specsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = label.getAttribute(open ? 'data-open-label' : 'data-closed-label');
        if (open) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      var initialSpecs = $$('[data-variant-specs]', section);
      if (initialSpecs.length && !initialSpecs.some(function (el) { return !el.hidden; })) initialSpecs[0].hidden = false;
    }

    var back = $('[data-history-back]', section);
    if (back && document.referrer && document.referrer.indexOf(window.location.origin) === 0 && window.history.length > 1) {
      back.addEventListener('click', function (e) { e.preventDefault(); window.history.back(); });
    }
  }

  /* ---------- Related products ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-recommendations'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-recommendations]');
          if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; $$('.reveal', el).forEach(function (r) { r.classList.add('is-visible'); }); }
          else { el.hidden = true; }
        })
        .catch(function () { el.hidden = true; });
    });
  }

  /* ---------- Dealer locator ---------- */
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    return new Promise(function (resolve, reject) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      s.onload = function () { resolve(window.L); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
  }

  function initDealers(root) {
    var stateSel = $('[data-dealer-state]', root);
    var search = $('[data-dealer-search]', root);
    var list = $('[data-dealer-list]', root);
    var countEl = $('[data-dealer-count]', root);
    var errorEl = $('[data-dealer-error]', root);
    var mapEl = $('[data-dealer-map]', root);
    var dealers = [];
    var map = null, layer = null, L = null;
    var LIMIT = 150;

    function render() {
      var st = stateSel.value;
      var q = search.value.trim().toLowerCase();
      var filtered = dealers.filter(function (d) {
        if (st && d.state !== st) return false;
        if (!q) return true;
        return (d.name + ' ' + d.city + ' ' + d.zip + ' ' + d.address).toLowerCase().indexOf(q) > -1;
      });
      countEl.textContent = filtered.length + ' ' + (countEl.getAttribute('data-label') || 'locations found');

      var groups = {};
      var order = [];
      filtered.forEach(function (d) {
        var key = d.name.trim().toLowerCase();
        if (!groups[key]) { groups[key] = []; order.push(key); }
        groups[key].push(d);
      });

      var html = '';
      order.slice(0, LIMIT).forEach(function (key) {
        var g = groups[key];
        var first = g[0];
        if (g.length === 1) {
          html += '<li class="dealer" data-lat="' + first.lat + '" data-lng="' + first.lng + '">' +
            '<div class="dealer__name">' + escapeHtml(first.name) + '</div>' +
            '<div class="dealer__meta">' + escapeHtml([first.address, first.city].filter(Boolean).join(', ')) + (first.state ? ', ' + escapeHtml(first.state) : '') + ' ' + escapeHtml(first.zip || '') + '</div>' +
            (first.phone ? '<div class="dealer__meta"><a href="tel:' + escapeHtml(first.phone) + '">' + escapeHtml(first.phone) + '</a></div>' : '') +
            (first.url ? '<div class="dealer__meta"><a href="' + escapeHtml(first.url) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(first.url.replace(/^https?:\/\//, '')) + '</a></div>' : '') +
            '</li>';
        } else {
          html += '<li class="dealer"><div class="dealer__name">' + escapeHtml(first.name) + '</div>' +
            '<div class="dealer__meta">' + g.length + ' ' + (countEl.getAttribute('data-locations') || 'locations') + '</div><ul class="dealer__locations">';
          g.slice(0, 25).forEach(function (d) {
            html += '<li class="dealer__meta" data-lat="' + d.lat + '" data-lng="' + d.lng + '">' + escapeHtml(d.city) + ', ' + escapeHtml(d.state) + ' ' + escapeHtml(d.zip || '') + (d.phone ? ' · <a href="tel:' + escapeHtml(d.phone) + '">' + escapeHtml(d.phone) + '</a>' : '') + '</li>';
          });
          if (g.length > 25) html += '<li class="dealer__meta">+ ' + (g.length - 25) + '</li>';
          html += '</ul></li>';
        }
      });
      if (order.length > LIMIT) html += '<li class="dealer-more">+ ' + (order.length - LIMIT) + ' more — filter by state or search a city or zip to narrow the list.</li>';
      list.innerHTML = html;

      if (map && L) {
        layer.clearLayers();
        var pts = [];
        filtered.forEach(function (d) {
          if (typeof d.lat !== 'number' || typeof d.lng !== 'number') return;
          pts.push([d.lat, d.lng]);
          L.circleMarker([d.lat, d.lng], { radius: 5, color: '#14181f', weight: 1, fillColor: getComputedStyle(document.documentElement).getPropertyValue('--color-primary') || '#ffcc00', fillOpacity: .9 })
            .bindPopup('<strong>' + escapeHtml(d.name) + '</strong><br>' + escapeHtml(d.address || '') + '<br>' + escapeHtml(d.city) + ', ' + escapeHtml(d.state) + ' ' + escapeHtml(d.zip || '') + (d.phone ? '<br>' + escapeHtml(d.phone) : ''))
            .addTo(layer);
        });
        if (pts.length) map.fitBounds(pts, { padding: [20, 20], maxZoom: 11 });
      }
    }

    list.addEventListener('click', function (e) {
      var item = e.target.closest('[data-lat]');
      if (!item || !map || e.target.closest('a')) return;
      map.setView([parseFloat(item.getAttribute('data-lat')), parseFloat(item.getAttribute('data-lng'))], 12);
      if (mapEl.scrollIntoView && window.innerWidth < 1024) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    fetch(root.getAttribute('data-src'))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        dealers = (Array.isArray(data) ? data : data.dealers || []).filter(function (d) { return d && d.name; });
        dealers.sort(function (a, b) { return a.name.localeCompare(b.name); });
        var states = {};
        dealers.forEach(function (d) { if (d.state) states[d.state.toUpperCase()] = true; d.state = (d.state || '').toUpperCase(); });
        Object.keys(states).sort().forEach(function (s) {
          var o = document.createElement('option'); o.value = s; o.textContent = s; stateSel.appendChild(o);
        });
        if (mapEl) {
          return loadLeaflet().then(function (leaflet) {
            L = leaflet;
            map = L.map(mapEl, { scrollWheelZoom: false }).setView([39.5, -98.35], 4);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
            layer = L.layerGroup().addTo(map);
          }).catch(function () { mapEl.hidden = true; });
        }
      })
      .then(render)
      .catch(function () { countEl.textContent = ''; errorEl.hidden = false; });

    var t;
    search.addEventListener('input', function () { clearTimeout(t); t = setTimeout(render, 200); });
    stateSel.addEventListener('change', render);
  }


  /* ---------- Category pages: lazy product cards & part tables ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch((theme.routes.root_url || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    return productCache[handle];
  }

  function initLazyCards(root) {
    var cards = $$('[data-lazy-card]', root);
    if (!cards.length) return;
    var queue = cards.slice();
    function next() {
      var el = queue.shift();
      if (!el) return Promise.resolve();
      var url = (theme.routes.root_url || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(el.getAttribute('data-lazy-card')) + '?section_id=product-card-ajax';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.product-card-wrap');
          if (card) { card.classList.add('is-visible'); el.replaceWith(card); } else { el.remove(); }
        })
        .catch(function () { el.remove(); })
        .then(next);
    }
    for (var i = 0; i < 6; i++) next();
  }

  function initPartTables(root) {
    var rows = $$('[data-part-row]', root);
    rows.forEach(function (row) {
      var handle = row.getAttribute('data-handle');
      getProduct(handle).then(function (p) {
        var variants = p.variants;
        if (row.hasAttribute('data-all-variants')) {
          var frag = document.createDocumentFragment();
          variants.forEach(function (v) {
            var tr = document.createElement('tr');
            tr.setAttribute('data-part-row', '');
            tr.innerHTML = '<td>' + escapeHtml(p.variants.length > 1 ? v.title : p.title) + '</td><td>' + escapeHtml(v.sku || '') + '</td><td data-part-price></td><td data-part-action></td>';
            fillRow(tr, v);
            frag.appendChild(tr);
          });
          row.replaceWith(frag);
          return;
        }
        var sku = (row.getAttribute('data-sku') || '').toUpperCase();
        var v = variants.find(function (x) { return (x.sku || '').toUpperCase() === sku; });
        if (v) fillRow(row, v); else row.remove();
      }).catch(function () { row.remove(); });
    });
  }

  function fillRow(row, v) {
    var price = row.querySelector('[data-part-price]');
    var action = row.querySelector('[data-part-action]');
    if (price) price.textContent = formatMoney(v.price);
    if (action) {
      if (v.available) {
        action.innerHTML = '<button type="button" class="btn btn--primary btn--sm" data-quick-add="' + v.id + '">' + escapeHtml(theme.strings.addToCart) + '</button>';
      } else {
        action.innerHTML = '<span class="text-muted text-xs">' + escapeHtml(theme.strings.soldOut) + '</span>';
      }
    }
  }

  /* ---------- Init ---------- */
  function init() {
    initReveal();
    initHeader();
    initCardThumbs();
    initCart();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    $$('[data-dealer-locator]').forEach(initDealers);
    initLazyCards(document);
    initPartTables(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    $$('.reveal', s).forEach(function (r) { r.classList.add('is-visible'); });
    $$('[data-product-section]', s).forEach(initProduct);
    $$('[data-dealer-locator]', s).forEach(initDealers);
  });
})();
